import React, { Component } from 'react';
import request from 'superagent';
import {Modal, Button, Spin, Radio} from 'antd';
import {ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, /*ReferenceLine,*/ Brush} from 'recharts';
import moment from 'moment';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class NginxRequestChartPopup extends Component {
    state = {
        data: [],
        selectValue: 'day',
        loading: false,
        visible: false
    };

    showModal = () => {
        this.fetch();
        this.setState({
            data: [],
            selectValue: 'day',
            visible: true
        });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    fetch = (params = {}) => {
        this.setState({loading: true});
        let selectValue = params;
        let url = '';
        if (selectValue === 'week') {
            url = '/api/dashboard/nginx/metric/week';
        } else if (selectValue === 'month') {
            url = '/api/dashboard/nginx/metric/month';
        } else {
            url = '/api/dashboard/nginx/metric';
        }
        //console.log(url);
        request.get(url)
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    let data = response.body;
                    if (selectValue === 'week' || selectValue === 'month') {
                        for (let i = 0; i < data.length; i++) {
                            let utcTime = moment(data[i].time).local();
                            data[i].time = utcTime.format("MM-DD HH:00");
                        }
                    } else {
                        for (let i = 0; i < data.length; i++) {
                            let utcTime = moment(data[i].time).local();
                            data[i].time = utcTime.format("HH:00");
                        }
                    }
                    this.setState({
                        loading: false,
                        data: data
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    onChange = (e) => {
        this.setState({selectValue: e.target.value});
        this.fetch(e.target.value);
    }

    render() {
        const data = this.state.data;
        const { visible, loading } = this.state;
        const selectValue = this.state.selectValue;

        return (
            <div>
                <a href="#" onClick={this.showModal}>More</a>

                <Modal visible={visible} title="Front End Server Requests" onCancel={this.handleCancel} maskClosable={false} width='1200px'
                       footer={[
                           <Button key="back" size="large" onClick={this.handleCancel}>Close</Button>,
                       ]}>
                    <div>
                        <Spin spinning={loading} tip="Loading...">
                            <div style={{textAlign: 'center', marginBottom: 20}}>
                                <RadioGroup onChange={this.onChange} value={selectValue}>
                                    <RadioButton value="day">Last day</RadioButton>
                                    <RadioButton value="week">Last week</RadioButton>
                                    <RadioButton value="month">Last month</RadioButton>
                                </RadioGroup>
                            </div>
                            <ResponsiveContainer width="100%" height={300}>
                                <AreaChart width={600} height={300} data={data}
                                           margin={{top: 0, right: 0, left: 0, bottom: 0}}>
                                    <XAxis dataKey="time"/>
                                    <YAxis/>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <Tooltip/>
                                    <Legend verticalAlign="top" height={54} align="center" iconType="square"/>
                                    {/*<ReferenceLine y={1000} label="Max" stroke="red" strokeDasharray="3 3" />*/}
                                    <Area type='monotone' dataKey='nginx1' unit=" Requests" stackId="1" stroke='#fba53f' fill='#fba53f'/>
                                    <Area type='monotone' dataKey='nginx2' unit=" Requests" stackId="1" stroke='#539a8e' fill='#539a8e'/>
                                    <Brush dataKey='time' height={30} stroke="#8884d8"/>
                                </AreaChart>
                            </ResponsiveContainer>
                        </Spin>
                    </div>

                </Modal>
            </div>

        );
    }
}
export default NginxRequestChartPopup;


// WEBPACK FOOTER //
// ./src/modules/dashboard/NginxRequestChartPopup.js